/**
 * Kết quả thêm danh mục
 * nxhinh 28/03/2024
 */
export default {
    /// <summary>
    /// Mẫu hợp lê
    /// </summary>
    Valid: 1,
  
    /// <summary>
    /// Mẫu chưa hợp lệ
    /// </summary>
    Invalid: 2,
    
    /// <summary>
    /// Trùng cấu trúc
    /// </summary>
    DuplicateStructure: 3,

    /// <summary>
    /// Chỉ có danh mục tổng hợp, không có danh mục con
    /// </summary>
    OnlyHaveParent: 4,
  };
  